import { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";
import { formatISO } from "date-fns";
import { consumirVale, getValeById } from "component/api";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import Grid from "@mui/material/Grid";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import Header from "component/Header/Header";
import Button from "@mui/material/Button";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "valeScanned",
  },
  dataLayerName: "Vales",
};

const ValeScanned = (props) => {
  TagManager.dataLayer(tagManagerArgs);

  const vaciadero = props.vaciadero;
  const header = props.header;

  let getValeContent = [];

  let getParams = function (url) {
    let params = {};
    let parser = document.createElement("a");
    parser.href = url;
    let query = parser.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  async function getValeByValeIdFunc(valeeId) {
    if (valeeId) {
      const res = await getValeById(valeeId);
      getValeContent = res.data;
      setCuentaContrato(getValeContent.empresa.cuentaContrato);
      setEmpresaNombre(getValeContent.empresa.razonSocial);
      setVale(getValeContent.tipoVale.id);
      setValeConsumido(getValeContent.estado);
    }
  }

  const [cuentaContrato, setCuentaContrato] = useState();
  const [empresaNombre, setEmpresaNombre] = useState();
  const [vale, setVale] = useState();
  const [idvale, setIdvale] = useState();
  const [messageErrorText, setMessageErrorText] = useState("");
  const [valeConsumido, setValeConsumido] = useState("");
  const [alert, setAlert] = useState(false);
  const [success, setSuccess] = useState(null);

  //let idvale = "";
  function getParamUrl() {
    if (vaciadero === true) {
      // window.alert(" localStorage vale " + localStorage.getItem("vale"));
      setIdvale(localStorage.getItem("vale"));
    }
    if (vaciadero === null) {
      setIdvale(getParams(window.location.href).idvale);
    }
    //window.alert("idvale" + idvale);
    // window.alert("header" + header);
  }

  const [error, setError] = useState("");

  function valem3() {
    if (vale == 1) {
      return 12;
    }
    if (vale == 2) {
      return 20;
    }
    if (vale == 3) {
      return 36;
    }
  }
  function valeId() {
    return idvale;
  }
  function valeIdText() {
    if (idvale !== null) {
      return <p> ID DE VALE : {idvale}</p>;
    }

    if (idvale === null) {
      return null;
    }
  }

  const fechaInicio = formatISO(new Date(), {
    representation: "date",
  });

  async function consumirValeFunc() {
    setIniciarMessage(false);
    if (idvale) {
      await consumirVale(idvale, 1)
        .then((response) => {
          localStorage.setItem("height", true);
          setMessageError(false);
          setSuccess(true);
        })

        .catch((err) => {
          setMessageError(true);
          setIniciarMessage(false);
          if (err.response.status === 403) {
            localStorage.setItem("height", false);
            setMessageErrorText(
              "Este vale ya fue consumido. Escaneá otro vale."
            );
            setAlert(true);
          }

          if (err.response.status === 412) {
            localStorage.setItem("height", false);
            setMessageErrorText("Ya no puede consumir mas Vales de este tipo.");
            setAlert(true);
          }
        });
    }
  }
  const [messageError, setMessageError] = useState(false);
  const [iniciarMessage, setIniciarMessage] = useState(false);

  useEffect(() => {
    try {
      getParamUrl();
      getValeByValeIdFunc(idvale);
      valeId();
      valeIdText();
      if (localStorage.getItem("rol") === "ROLE_VACIADERO") {
        consumirValeFunc();
      }
      if (localStorage.getItem("rol") === "ROLE_EMPRESA") {
        setMessageError(false);
        setIniciarMessage(false);
        setAlert(false);
        setSuccess(false);
      }
      if (localStorage.getItem("rol") === null) {
        setIniciarMessage(true);
        setMessageError(false);
        setAlert(true);
        setSuccess(false);
      }
    } catch (err) {
      setError(err);
      console.log(error);
    }
  }, [idvale]);

  const baseUrl = "https://" + window.location.host;

  const buttonSalir = (
    <Link
      to="/backOffice"
      style={{ textDecoration: "none", alignSelf: "center" }}
    >
      <Button
        variant="contained"
        style={{
          width: "50%",
          textTransform: "none",
          backgroundColor: "#F86436",
          color: "white",
        }}
        onClick={() => {
          localStorage.clear();
          sessionStorage.clear();
        }}
      >
        {" "}
        Salir
      </Button>
    </Link>
  );

  const valeInfo = (
    <Container maxWidth="md">
      <Container
        maxWidth="70%"
        style={{
          marginTop: "4%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignSelf: "center",
        }}
      >
        {iniciarMessage === true && <h2>Por favor inicie sesión.</h2>}
        {alert === false && (
          <div>
            <div
              style={{
                backgroundColor: "#C2E3C3",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              {success === true && (
                <Grid container sx={{ width: "100%" }}>
                  <Grid size={{ xs: 2 }}>
                    <CheckCircleOutlineSharpIcon
                      fontSize="large"
                      style={{
                        marginTop: "10%",
                        marginLeft: "25%",
                        color: "green",
                      }}
                    />
                  </Grid>
                  <Grid size="grow">
                    <p>Vale consumido exitosamente.</p>
                  </Grid>
                </Grid>
              )}
            </div>
            <br />

            <div
              style={{
                border: "black 1px ridge",
                width: "100%",
                alignSelf: "center",
              }}
            >
              <Container
                maxWidth="md"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignSelf: "center",
                }}
              >
                <br />

                <div>
                  <p style={{ alignSelf: "center", marginTop: "1%" }}>
                    NOMBRE Y APELLIDO/EMPRESA: {empresaNombre}
                    <br />
                    NÚMERO DE CUENTA: {cuentaContrato}
                    <br />
                    {valeIdText()}
                    FECHA: {fechaInicio}
                  </p>
                  <div
                    style={{
                      border: " solid #1E90FF ",
                      marginRight: "10%",
                      marginLeft: "10%",
                      marginBottom: "5%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <img
                        style={{
                          margin: "3%",
                          alignSelf: "center",
                        }}
                        src="https://www.aysa.com.ar/assets/Menu/img/logo.png"
                        alt="aysa logo"
                      />
                    </div>
                    <div
                      style={{
                        backgroundColor: "#B0E0E6",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <h1 style={{ alignSelf: "center", marginBottom: "-2%" }}>
                        Vale descarga
                      </h1>
                      <h2 style={{ alignSelf: "center", color: "#1E90FF " }}>
                        Hasta {valem3()} m3
                      </h2>

                      <Link
                        to={`/backoffice/vaciadero?idvale=${idvale}`}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <QRCodeSVG
                          bgColor="#FFFFFF"
                          fgColor="#000000"
                          level="Q"
                          style={{ maxWidth: 150, alignSelf: "center" }}
                          value={`${baseUrl}/backoffice/vaciadero?idvale=${idvale}`}
                        />
                      </Link>

                      <br />
                      <div style={{ alignSelf: "center" }}>{idvale}</div>
                    </div>
                  </div>
                </div>

                <br />
              </Container>
            </div>

            <br />
          </div>
        )}
        {messageError === true && (
          <div>
            <div
              style={{
                backgroundColor: "#F9CDD0",
                border: "red 1px ridge",
                width: vaciadero ? "100%" : "80%",

                marginBottom: "10px",
              }}
            >
              <Grid container sx={{ width: "100%" }}>
                <Grid size={{ xs: 2 }}>
                  <ErrorRoundedIcon
                    fontSize="large"
                    color="secondary"
                    style={{ marginTop: "12%", marginLeft: "25%" }}
                  />
                </Grid>
                <Grid size="grow">
                  <div style={{ marginTop: "3%" }}>{messageErrorText}</div>
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </Container>
    </Container>
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div>
        {header === null && iniciarMessage === false && (
          <Header button={buttonSalir} />
        )}
        {header === null && iniciarMessage === true && <Header />}

        <div>{valeInfo}</div>
      </div>

      <br />
    </div>
  );
};

export default ValeScanned;
